import { buildProps as o, definePropType as n } from "./index601.js";
const t = o({
  /** @description Indicates the reference element to which the popper is attached */
  virtualRef: {
    type: n(Object)
  },
  /** @description Indicates whether virtual triggering is enabled */
  virtualTriggering: Boolean,
  onMouseenter: {
    type: n(Function)
  },
  onMouseleave: {
    type: n(Function)
  },
  onClick: {
    type: n(Function)
  },
  onKeydown: {
    type: n(Function)
  },
  onFocus: {
    type: n(Function)
  },
  onBlur: {
    type: n(Function)
  },
  onContextmenu: {
    type: n(Function)
  },
  id: String,
  open: Boolean
});
export {
  t as popperTriggerProps
};
